/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMedal = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2a7 7 0 0 1 5.002 11.897L17 22.618l-5-2.5-5 2.5v-8.72A7 7 0 0 1 12 2zm3 13.326a6.948 6.948 0 0 1-1.644.543l-.035.005c-.203.04-.41.07-.62.091l-.085.008A6.322 6.322 0 0 1 12 16l.303-.006a7.12 7.12 0 0 1-.919-.02l-.086-.01a6.984 6.984 0 0 1-.619-.088c-.011-.004-.023-.006-.034-.008A6.894 6.894 0 0 1 9 15.326v4.055l3-1.499 3 1.5zM12 4a5 5 0 0 0-3.523 8.548l.19.17a4.978 4.978 0 0 0 2.581 1.226l-.05-.009c.071.012.143.022.215.03l-.165-.021c.09.013.18.024.27.033l-.105-.011c.1.011.202.02.304.026l-.199-.015c.073.007.147.012.221.016L12 14a5.032 5.032 0 0 0 .283-.008l-.022.001c.074-.004.148-.01.221-.016l-.199.015c.102-.006.203-.014.304-.026l-.105.01c.09-.008.18-.02.27-.033l-.165.023c.072-.008.144-.018.215-.03l-.05.007a4.976 4.976 0 0 0 2.58-1.224l.189-.169A5 5 0 0 0 12 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMedal as Medal };
